export const permissionsKeys = {
  page: 'content-management.events-schedule',
  pageBlockFind: 'content-management.events-schedule.find',
  pageBlockCreate: 'content-management.events-schedule.create',
  pageBlockUpdate: 'content-management.events-schedule.update',
  pageBlockRemove: 'content-management.events-schedule.remove',
  pageBlockUpdatePublish: 'content-management.publish.events-schedule.update',
  pageBlockUpdateStatusToDraft: 'content-management.events-schedule.updateStatusToDraft',
  pageBlockUpdateInactivate: 'content-management.inactivate.events-schedule.update',
  pageBlockUpdateActive: 'content-management.active.events-schedule.update',
} as const;
